module.exports = __webpack_public_path__ + "images/emoji/ok_woman.b58ce5a3525925c57557.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ok_woman.png
// module id = 0f4B
// module chunks = 2